module.exports = __webpack_public_path__ + "assets/img/ty1.2e7a48cc.jpg";